import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {verifyLoggedIn} from '../../store/auth/actions';
import {BllinkLogger} from '../utils/bllink_loggers';
import {useClient} from "./useClient";
import {useTenantApiClient} from "../../tenants/profile/hooks/useTenantApiClient";

/**
 * if the user is logged in, then use their access token,
 * if not then not, but don't redirect to login page if not
 * @return {ServerData}
 * */
export function optionalUseAccessToken({forceManager = false} = {}) {
    const dispatch = useDispatch();
    const accessToken = useSelector(state => state.auth.accessToken) ?? '';
    const accessTokenTenant = useSelector(state => state.tenantProfile?.accessToken);
    let client;
    // to support also new tenant section chat
    if (accessTokenTenant && !forceManager){
        client = useTenantApiClient();
    }else{
        client = useClient(accessToken);
    }

    useEffect(async function() {
        if (accessToken === '') {
            try {
                await dispatch(verifyLoggedIn({avoidExceptionOnNotLogged: true}));
            } catch (e) {
                // todo also check if a tenant is logged in to create a client for them
                BllinkLogger.info(`user is not authenticated`, e);
            }
        }
    });

    return client;
}
